<script>
    import { PowerTable } from "@muonw/powertable";
    import powerTableService from "../../../../../services/powerTable.js";
    import { format } from "svelte-i18n";

    let { rels = [] } = $props();
    let tableElement = $state();

    let ptOptions = {
        uniquePrefix: "assetRelations",
        rowsPerPageOptions: [10, 20, 50, 100],
        rowsPerPage: 10,
        footerText: false,
        footerFilters: false,
        footerLoadingBar: false,
        segments: {
            topBar: ["search"],
            pTable: ["table"],
            bottomBar: ["dropdown", "stats", "pagination"],
        },
        translations: powerTableService.getTableTranslations(),
        isDataRemote: false,
        userFunctions: {},
    };

    let ptInstructs = [
        { key: "kind", title: $format("list.columns.kind"), filterable: false },
        {
            key: "from_asset_id",
            title: $format("list.columns.direction"),
            filterable: false,
            parseAs: "unsafe-html",
        },
        {
            key: "to_asset_id",
            title: $format("list.columns.asset"),
            filterable: false,
            parseAs: "unsafe-html",
        },
        {key: 'finding_count', title: $format("list.columns.findings"), parseAs: 'unsafe-html',  filterable: false, parseAs: 'unsafe-html', userFunctions: {customSort: powerTableService.sortFindings}}
    ];

    let ptData = $derived(rels);
</script>

{#key ptData}
    <PowerTable {ptData} {ptInstructs} {ptOptions} bind:this={tableElement}>
        {#snippet noResults()}
            <div>
                {$format("results_not_found")}
            </div>
        {/snippet}
    </PowerTable>
{/key}

<style>
</style>
